/**
 * Built-in parsers — the registration point.
 *
 * Adding a format is adding one import and one array entry here. Nothing else
 * in the engine changes: not the registry, not the importer, not the public
 * API. That property is the point of Phase 1, and this file is where it is
 * cashed in.
 *
 * SVG, Figma, Canva, PSD, and PDF follow the same one-line path the JSON
 * parser took.
 */

import { parserRegistry } from '../parserRegistry';
import { jsonParser } from './jsonParser';

/** @type {import('../types').Parser[]} */
export const BUILT_IN_PARSERS = [jsonParser];

/**
 * Register every built-in parser. Idempotent: the registry replaces by id, so
 * calling this twice leaves one copy of each parser rather than two.
 */
export const registerBuiltInParsers = () => {
  BUILT_IN_PARSERS.forEach((parser) => parserRegistry.register(parser));
};
